import React from 'react';
import PropTypes from 'prop-types';

import ICD10DiagnosisDialog
  from '../../../../../Common/components/Diagnosis/ICD10DiagnosisDialog';

import VSHx from '../VSHx/VSHx';
import SubjectiveTemplatesDialog
  from '../TemplatesModal/SubjectiveTemplatesDialog';

import ObjectiveTemplatesDialog
  from '../TemplatesModal/ObjectiveTemplatesDialog';

import AssessmentTemplatesDialog
  from '../TemplatesModal/AssessmentTemplatesDialog';

import OrdersDialog, {
  ORDER_TYPES
} from '../TemplatesModal/OrdersDialog';

import RxDialog
  from '../TemplatesModal/RxDialog';

const SoapEntryDialogs = ({
  state,
  handlers
}) => {
  const {
    openVSHx,
    openSubjective,
    openObjective,
    openAssessmentTemplates,
    openICD10Diagnosis,
    openRX,
    openLabOrders,
    openImageOrders,
    openPhysicianOrders,

    selectedICD10Diagnoses,
    signedLabOrder,
    signedImageOrder,
    signedPhysicianOrder,
    orderTemplateText
  } = state;

  return (
    <>
      <VSHx
        open={openVSHx}
        onCancel={handlers.closeVSHx}
      />

      <SubjectiveTemplatesDialog
        open={openSubjective}
        onClose={handlers.closeSubjective}
        onSave={handlers.saveSubjective}
      />

      <ObjectiveTemplatesDialog
        open={openObjective}
        onClose={handlers.closeObjective}
        onSave={handlers.saveObjective}
      />

      <AssessmentTemplatesDialog
        open={openAssessmentTemplates}
        onClose={handlers.closeAssessmentTemplates}
        onSave={handlers.saveAssessmentTemplate}
      />

      <RxDialog
        open={openRX}
        onClose={handlers.closeRX}
        onSignAndClose={handlers.signPrescription}
        onSignAndPrint={handlers.signPrescription}
      />

      <ICD10DiagnosisDialog
        open={openICD10Diagnosis}
        selectedDiagnoses={selectedICD10Diagnoses}
        onClose={handlers.closeDiagnosis}
        onSave={handlers.saveDiagnosis}
      />

      <OrdersDialog
        type={ORDER_TYPES.LAB}
        open={openLabOrders}
        initialValue={signedLabOrder}
        templateValue={orderTemplateText[ORDER_TYPES.LAB]}
        onClose={handlers.closeLab}
        onSignAndClose={handlers.signLab}
        onSignAndPrint={handlers.signLab}
        onOpenTemplates={() =>
          handlers.openTemplate(ORDER_TYPES.LAB)
        }
      />

      <OrdersDialog
        type={ORDER_TYPES.IMAGING}
        open={openImageOrders}
        initialValue={signedImageOrder}
        templateValue={orderTemplateText[ORDER_TYPES.IMAGING]}
        onClose={handlers.closeImaging}
        onSignAndClose={handlers.signImaging}
        onSignAndPrint={handlers.signImaging}
        onOpenTemplates={() =>
          handlers.openTemplate(ORDER_TYPES.IMAGING)
        }
      />

      <OrdersDialog
        type={ORDER_TYPES.PHYSICIAN}
        open={openPhysicianOrders}
        initialValue={signedPhysicianOrder}
        templateValue={orderTemplateText[ORDER_TYPES.PHYSICIAN]}
        onClose={handlers.closePhysician}
        onSignAndClose={handlers.signPhysician}
        onSignAndPrint={handlers.signPhysician}
        onOpenTemplates={() =>
          handlers.openTemplate(ORDER_TYPES.PHYSICIAN)
        }
      />
    </>
  );
};

SoapEntryDialogs.propTypes = {
  state: PropTypes.object.isRequired,
  handlers: PropTypes.object.isRequired
};

export default SoapEntryDialogs;